import { render } from "./TournamentPage.vue?vue&type=template&id=7e719f8e"
import script from "./TournamentPage.vue?vue&type=script&lang=js"
export * from "./TournamentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__